import { useState } from 'react';
import type { TimelineItem } from '../types/types';

export interface TimelineEntry {
  item: TimelineItem;
  isPinned: boolean;
}

const useTimelineEntries = (items: TimelineItem[]) => {
  const [pinnedItems, setPinnedItems] = useState(
    new Map<TimelineItem['id'], { item: TimelineItem; isPinned: boolean }>(),
  );
  const entries: TimelineEntry[] = items
    .map(item => {
      const override = pinnedItems.get(item.id);
      const isPinned = override?.item === item ? override.isPinned : (item.isPinned ?? false);

      return { item, isPinned };
    })
    .sort((left, right) => Number(right.isPinned) - Number(left.isPinned));

  const setPinned = (item: TimelineItem, isPinned: boolean) => {
    setPinnedItems(current => new Map(current).set(item.id, { item, isPinned }));
  };

  return { entries, setPinned };
};

export default useTimelineEntries;
